import {
  collection,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { type FirestoreSectionPassCoupon, schema } from './schema'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { modelListStream } from '../../firestore-mobx/stream'
import { SectionPassCoupon } from '../../models/SectionPassCoupon'

const converter: FirestoreDataConverter<FirestoreSectionPassCoupon> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getColRef = (firestore: Firestore, sectionId: string) => {
  return collection(
    firestore,
    'section',
    sectionId,
    'section_pass_coupon'
  ).withConverter(converter)
}

export const getSectionPassCouponsForSection = (
  repository: FirebaseRepository,
  { sectionId }: { sectionId: string }
) => {
  return modelListStream(
    repository,
    getColRef(repository.firestore, sectionId),
    SectionPassCoupon
  )
}
